"use client"

import { SentenceBaseEntity } from "@/app/entities/SentenceEntity"
import fetchInterceptorInClient from "@/components/fetcher/fetchInterceptorInClient"
import {
  resultPostprocessing2,
} from "@/components/fetcher/fetchInterceptor"

const ROOT = process.env.NEXT_PUBLIC_ROOT

export type SentenceContinuationItem = {
  sentence: SentenceBaseEntity
  folderIds: string[]
}

type Response = SentenceContinuationItem[]

const fetchClientSentencesRecent = ({
  limit,
}: {
  limit?: number
} = {}) =>
  fetchInterceptorInClient(
    {
      method: "get",
      credentials: "same-origin",
    },
    ROOT,
  )(() => `/api/notebook/sentence-continuations/my`, {
    ...(limit && { limit }),
  }).then(resultPostprocessing2<Response>)
export default fetchClientSentencesRecent
